import { PATHS } from '~/oakra/components/base-app'

type PathKeys = keyof typeof PATHS

type ExtractParams<S extends string> = string extends S
    ? never
    : S extends `${infer _Start}:${infer Param}/${infer Rest}`
      ? { [k in Param | keyof ExtractParams<Rest>]: string }
      : S extends `${infer _Start}:${infer Param}`
        ? { [k in Param]: string }
        : NonNullable<unknown>

type PathsNeedParams = {
    [K in PathKeys]: (typeof PATHS)[K] extends `${string}:${string}` ? K : never
}[PathKeys]

export function getPath<Path extends PathKeys>(
    path: Path,
    params?: Path extends PathsNeedParams ? ExtractParams<(typeof PATHS)[Path]> : never
): string {
    let pathValue: string = PATHS[path]

    if (params) {
        Object.entries(params).forEach(([key, value]) => {
            pathValue = pathValue.replace(`:${key}`, value)
        })
    }

    return pathValue
}
